const columns = [
    {
        field: "id",
        headerName: "Invoice #",
        description: "Invoice ID",
        maxWidth: 90,
        flex: 1,
    },
    {
        field: "OtherParty",
        headerName: "Customer",
        minWidth: 200,
        flex: 2,
        valueGetter: (OtherParty) => {
            return `${OtherParty?.name}: ${OtherParty?.phone}`;
        },
    },
    {
        field: "priceFinal",
        headerName: "Total Amount",
        minWidth: 120,
        flex: 1,
        valueFormatter: (params) => {
            return typeof params === "number" ? params.toFixed(4) : params;
        },
    },
    {
        field: "paidAmount",
        headerName: "Paid Amount",
        minWidth: 120,
        flex: 1,
        valueFormatter: (params) => {
            return typeof params === "number" ? params.toFixed(4) : params;
        },
    },
    {
        field: "remainingAmount",
        headerName: "Remaining",
        minWidth: 120,
        flex: 1,
        cellClassName: "remaining-amount-cell",
        valueFormatter: (params) => {
            return typeof params === "number" ? params.toFixed(4) : params;
        },
    },
    {
        field: "createdAt",
        headerName: "Invoice Date",
        minWidth: 180,
        flex: 1.5,
        valueGetter: (createdAt) => {
            return new Date(createdAt).toLocaleString();
        },
    },
];

const Get_URI = "/invoices/unpaid";
const Get_Customer_URI = (id) => `/invoices/unpaid/customer/${id}`;

export { columns, Get_URI, Get_Customer_URI };
